import { PageComponent } from '@root/pages/Type';
import { MethodRecordItem } from '../Types';
import Method from './Method';

export type MacroMethodsProps = {
    amountValue: any;
    currentMethod: number;
    methods: MethodRecordItem[];
    onChooseMethod: (value: number) => void;
};

const Methods: PageComponent<MacroMethodsProps> = ({ methods, ...props }) => {
    return (
        <>
            {methods.map((method) => <Method method={method} key={method.value} {...props}/>)}
        </>
    );
};

export default Methods;
